import { useState, useEffect } from 'react';
import { deviceController } from '../../controllers/deviceController';
import { Package, Plus, Edit2, Trash2, X, Search, Download } from 'lucide-react';

const EMPTY_APP = { name: '', version: '', platform: 'Android', category: 'Productivity', status: 'Active', mandatory: false, size: '', description: '', bundleId: '' };

const AppManagementPage = () => {
  const [apps, setApps] = useState([
    { id: 1, name: 'Microsoft Teams', version: '5.12.0', platform: 'All', category: 'Communication', status: 'Active', mandatory: true, size: '142 MB', description: 'Team collaboration app', bundleId: 'com.microsoft.teams', installedCount: 0 },
    { id: 2, name: 'Company VPN', version: '2.3.1', platform: 'All', category: 'Security', status: 'Active', mandatory: true, size: '28 MB', description: 'Corporate VPN client', bundleId: 'com.company.vpn', installedCount: 0 },
    { id: 3, name: 'Outlook', version: '4.2139.0', platform: 'iOS', category: 'Productivity', status: 'Active', mandatory: true, size: '215 MB', description: 'Email and calendar', bundleId: 'com.microsoft.outlook', installedCount: 0 },
    { id: 4, name: 'Chrome Browser', version: '124.0', platform: 'Android', category: 'Browser', status: 'Active', mandatory: false, size: '95 MB', description: 'Web browser', bundleId: 'com.android.chrome', installedCount: 0 },
  ]);
  const [devices, setDevices] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterPlatform, setFilterPlatform] = useState('All');
  const [filterCategory, setFilterCategory] = useState('All');
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selected, setSelected] = useState(null);
  const [formData, setFormData] = useState(EMPTY_APP);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    deviceController.getAll().then(r => {
      if (r.success) setDevices(r.data);
      setLoading(false);
    });
  }, []);

  const handleInput = e => setFormData(prev => ({ ...prev, [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));

  const filtered = apps.filter(a => {
    const q = searchQuery.toLowerCase();
    const matchQ = !searchQuery || a.name.toLowerCase().includes(q) || a.bundleId?.toLowerCase().includes(q);
    const matchP = filterPlatform === 'All' || a.platform === filterPlatform || a.platform === 'All';
    const matchC = filterCategory === 'All' || a.category === filterCategory;
    return matchQ && matchP && matchC;
  });

  const categories = [...new Set(apps.map(a => a.category))];

  const s = {
    page: { padding: 0 },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' },
    titleWrap: { display: 'flex', alignItems: 'center', gap: '12px' },
    icon: { width: '44px', height: '44px', borderRadius: '12px', backgroundColor: '#f97316' + '20', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    title: { fontSize: '26px', fontWeight: '700', color: '#1e293b', margin: 0 },
    subtitle: { fontSize: '13px', color: '#64748b', marginTop: '2px' },
    btnPrimary: { display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 18px', backgroundColor: '#f97316', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' },
    btnSecond: { backgroundColor: '#fff', color: '#1e293b', border: '1px solid #e2e8f0' },
    btnDanger: { backgroundColor: '#ef4444', color: '#fff', border: 'none' },
    statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '14px', marginBottom: '22px' },
    statCard: { backgroundColor: '#fff', padding: '18px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', borderLeft: '3px solid #f97316' },
    statLabel: { fontSize: '12px', color: '#64748b', marginBottom: '6px' },
    statVal: { fontSize: '26px', fontWeight: '700' },
    filterBar: { display: 'flex', gap: '10px', marginBottom: '18px', flexWrap: 'wrap' },
    searchWrap: { flex: 1, minWidth: '220px', position: 'relative' },
    searchIn: { width: '100%', padding: '10px 10px 10px 38px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
    searchIco: { position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' },
    select: { padding: '10px 14px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', outline: 'none', backgroundColor: '#fff', cursor: 'pointer' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '14px' },
    appCard: { backgroundColor: '#fff', borderRadius: '12px', padding: '18px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', border: '1px solid #f1f5f9' },
    badge: { display: 'inline-block', padding: '2px 8px', borderRadius: '8px', fontSize: '10px', fontWeight: '600' },
    actBtn: { padding: '5px', backgroundColor: 'transparent', border: 'none', borderRadius: '6px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center' },
    modal: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
    mContent: { backgroundColor: '#fff', borderRadius: '14px', width: '90%', maxWidth: '560px', maxHeight: '90vh', overflow: 'auto' },
    mHeader: { padding: '18px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 },
    mTitle: { fontSize: '18px', fontWeight: '600', color: '#1e293b', margin: 0 },
    mBody: { padding: '24px' },
    mFooter: { padding: '14px 24px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: '10px' },
    fGroup: { marginBottom: '16px' },
    label: { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '500', color: '#374151' },
    input: { width: '100%', padding: '9px 12px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
    textarea: { width: '100%', padding: '9px 12px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', outline: 'none', resize: 'vertical', minHeight: '70px', boxSizing: 'border-box' },
    grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' },
  };

  const platformColor = { All: '#8b5cf6', Android: '#34a853', iOS: '#007aff', Windows: '#0078d4' };
  const catColors = { Communication: '#3b82f6', Security: '#ef4444', Productivity: '#10b981', Browser: '#f97316', Utility: '#8b5cf6' };

  const FormBody = () => (
    <div style={s.mBody}>
      <div style={s.grid2}>
        <div style={s.fGroup}><label style={s.label}>App Name *</label><input name="name" style={s.input} value={formData.name} onChange={handleInput} required /></div>
        <div style={s.fGroup}><label style={s.label}>Version</label><input name="version" style={s.input} value={formData.version} onChange={handleInput} placeholder="e.g. 1.0.0" /></div>
        <div style={s.fGroup}><label style={s.label}>Bundle ID</label><input name="bundleId" style={s.input} value={formData.bundleId} onChange={handleInput} placeholder="com.example.app" /></div>
        <div style={s.fGroup}><label style={s.label}>Size</label><input name="size" style={s.input} value={formData.size} onChange={handleInput} placeholder="e.g. 50 MB" /></div>
        <div style={s.fGroup}><label style={s.label}>Platform</label>
          <select name="platform" style={s.input} value={formData.platform} onChange={handleInput}>
            <option value="All">All</option><option value="Android">Android</option><option value="iOS">iOS</option><option value="Windows">Windows</option>
          </select>
        </div>
        <div style={s.fGroup}><label style={s.label}>Category</label>
          <select name="category" style={s.input} value={formData.category} onChange={handleInput}>
            <option value="Productivity">Productivity</option><option value="Communication">Communication</option><option value="Security">Security</option><option value="Browser">Browser</option><option value="Utility">Utility</option>
          </select>
        </div>
      </div>
      <div style={s.fGroup}><label style={s.label}>Description</label><textarea name="description" style={s.textarea} value={formData.description} onChange={handleInput} /></div>
      <div style={{ display: 'flex', gap: '20px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
          <input type="checkbox" name="mandatory" checked={formData.mandatory} onChange={handleInput} style={{ accentColor: '#f97316', cursor: 'pointer' }} /> Mandatory Install
        </label>
      </div>
    </div>
  );

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.titleWrap}>
          <div style={s.icon}><Package size={22} color="#f97316" /></div>
          <div><h1 style={s.title}>App Management</h1><div style={s.subtitle}>{apps.length} apps managed</div></div>
        </div>
        <button style={s.btnPrimary} onClick={() => { setFormData(EMPTY_APP); setShowAdd(true); }}><Plus size={15} /> Add App</button>
      </div>

      <div style={s.statsGrid}>
        {[['Total Apps', apps.length, '#f97316'], ['Mandatory', apps.filter(a => a.mandatory).length, '#ef4444'], ['Active', apps.filter(a => a.status === 'Active').length, '#10b981'], ['Managed Devices', devices.length, '#3b82f6']].map(([l, v, c]) => (
          <div key={l} style={{ ...s.statCard, borderLeftColor: c }}><div style={s.statLabel}>{l}</div><div style={{ ...s.statVal, color: c }}>{v}</div></div>
        ))}
      </div>

      <div style={s.filterBar}>
        <div style={s.searchWrap}>
          <Search size={15} style={s.searchIco} />
          <input type="text" placeholder="Search apps..." style={s.searchIn} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
        </div>
        <select style={s.select} value={filterPlatform} onChange={e => setFilterPlatform(e.target.value)}>
          <option value="All">All Platforms</option><option value="Android">Android</option><option value="iOS">iOS</option><option value="Windows">Windows</option>
        </select>
        <select style={s.select} value={filterCategory} onChange={e => setFilterCategory(e.target.value)}>
          <option value="All">All Categories</option>
          {categories.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <div style={s.grid}>
        {filtered.map(app => (
          <div key={app.id} style={s.appCard}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)'}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
              <div style={{ width: '42px', height: '42px', borderRadius: '10px', backgroundColor: `${catColors[app.category] || '#6b7280'}15`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Package size={20} color={catColors[app.category] || '#6b7280'} />
              </div>
              <div style={{ display: 'flex', gap: '4px' }}>
                {app.mandatory && <span style={{ ...s.badge, backgroundColor: '#ef444415', color: '#ef4444' }}>Mandatory</span>}
                <span style={{ ...s.badge, backgroundColor: `${platformColor[app.platform] || '#6b7280'}15`, color: platformColor[app.platform] || '#6b7280' }}>{app.platform}</span>
              </div>
            </div>
            <div style={{ fontWeight: '600', fontSize: '15px', color: '#1e293b', marginBottom: '2px' }}>{app.name}</div>
            <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '6px' }}>v{app.version} · {app.size}</div>
            <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '12px' }}>{app.bundleId}</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '10px', borderTop: '1px solid #f1f5f9' }}>
              <span style={{ ...s.badge, padding: '3px 10px', backgroundColor: `${catColors[app.category] || '#6b7280'}15`, color: catColors[app.category] || '#6b7280', fontSize: '11px' }}>{app.category}</span>
              <div style={{ display: 'flex', gap: '2px' }}>
                <button style={s.actBtn} onClick={() => { setSelected(app); setFormData({ name: app.name, version: app.version, platform: app.platform, category: app.category, status: app.status, mandatory: app.mandatory, size: app.size, description: app.description, bundleId: app.bundleId }); setShowEdit(true); }}><Edit2 size={14} color="#3b82f6" /></button>
                <button style={s.actBtn} onClick={() => { setSelected(app); setShowDelete(true); }}><Trash2 size={14} color="#ef4444" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {(showAdd || showEdit) && (
        <div style={s.modal} onClick={() => { setShowAdd(false); setShowEdit(false); }}>
          <div style={s.mContent} onClick={e => e.stopPropagation()}>
            <div style={s.mHeader}><h2 style={s.mTitle}>{showAdd ? 'Add App' : 'Edit App'}</h2><button style={s.actBtn} onClick={() => { setShowAdd(false); setShowEdit(false); }}><X size={18} /></button></div>
            <form onSubmit={async (e) => {
              e.preventDefault(); setSubmitting(true);
              await new Promise(r => setTimeout(r, 400));
              if (showAdd) setApps(prev => [...prev, { id: Date.now(), ...formData, installedCount: 0 }]);
              else setApps(prev => prev.map(a => a.id === selected.id ? { ...a, ...formData } : a));
              setShowAdd(false); setShowEdit(false); setSubmitting(false);
            }}>
              <FormBody />
              <div style={s.mFooter}><button type="button" style={{ ...s.btnPrimary, ...s.btnSecond }} onClick={() => { setShowAdd(false); setShowEdit(false); }}>Cancel</button><button type="submit" style={s.btnPrimary} disabled={submitting}>{submitting ? 'Saving...' : (showAdd ? 'Add App' : 'Save')}</button></div>
            </form>
          </div>
        </div>
      )}

      {showDelete && selected && (
        <div style={s.modal} onClick={() => setShowDelete(false)}>
          <div style={{ ...s.mContent, maxWidth: '380px' }} onClick={e => e.stopPropagation()}>
            <div style={s.mHeader}><h2 style={s.mTitle}>Remove App</h2><button style={s.actBtn} onClick={() => setShowDelete(false)}><X size={18} /></button></div>
            <div style={s.mBody}><div style={{ textAlign: 'center' }}><div style={{ width: '56px', height: '56px', borderRadius: '50%', backgroundColor: '#fee2e2', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Trash2 size={24} color="#ef4444" /></div><p style={{ color: '#1e293b', fontWeight: '500' }}>Remove "{selected.name}"?</p></div></div>
            <div style={s.mFooter}><button style={{ ...s.btnPrimary, ...s.btnSecond }} onClick={() => setShowDelete(false)}>Cancel</button><button style={{ ...s.btnPrimary, ...s.btnDanger }} onClick={() => { setApps(prev => prev.filter(a => a.id !== selected.id)); setShowDelete(false); }}>Remove</button></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppManagementPage;